import { Outlet } from "react-router-dom";
import ProtectedRoute from "@/routes/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { RouteAccess } from "@/enum/common.enum";

export default function DashboardShell() {
  return (
    <ProtectedRoute allow={RouteAccess.INTERNAL}>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </ProtectedRoute>
  );
}
